import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from "react-error-boundary";

import i18n from './i18n'  // Initialize i18n
import App from './App.tsx'
import { ErrorFallback } from './ErrorFallback.tsx'

import "./main.css"
import "./styles/theme.css"
import "./index.css"

// Set application document title (localized)
document.title = i18n.t('appTitle')

// Register service worker for PWA functionality in production only.
// In dev, unregister any existing SW to avoid HMR websocket issues.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((registration) => {
        console.log('SW registered:', registration)

        // If there's an updated SW waiting, trigger activation
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        }

        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              // If new worker is waiting, activate it
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' })
              }
            }
          })
        })

        // Reload any clients controlled by the new SW
        let refreshing = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return
          refreshing = true
          window.location.reload()
        })
      }).catch((err) => {
        console.log('SW registration failed:', err)
      })
    })
  } else {
    // Dev: ensure no SW controls the page (prevents Vite HMR ws failures)
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(reg => {
          // Only unregister our app SWs; safe to unregister all in dev environment
          reg.unregister().then(() => console.log('SW unregistered in dev:', reg.scope))
        })
      })
      .catch(() => { /* ignore */ })
  }
}

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <App />
   </ErrorBoundary>
)
